// routes
import { PATH_SalesUser, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// ------------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
const ICONS = {
    dashboard: icon('ic_dashboard'),
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    noneligibleRecords: icon('ic_noneligible'),
    enablereupload: icon('ic_reupload'),
    dealerrequest: icon('ic_request'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
    helpdesk: icon('communication'),
    data: icon('ic_data'),
};

const isHnCActive = AppCache?.GetCurrentLoggedInUser()?.IsHnCActive;

const userRole = AppCache?.GetCurrentLoggedInUser()?.UserRoleName;
// console.log('userRole', userRole)

const navConfig = [
    //   GENERAL
    //   -----------------------------------------------------------------------------------------------------
    {
        // subheader: 'Report',

        items: [
            { title: 'Dealer Sales Upload', path: PATH_SalesUser.dataUploadApprove, icon: ICONS.dataUpload },
            // { title: 'My Dealers Dashboard', path: PATH_SalesUser.dealerlistpage, icon: ICONS.dashboard },
            { title: 'My Dealers Dashboard', path: PATH_SalesUser.powerbidashboard, icon: ICONS.dashboard },
            { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            ...((userRole !== 'NSM Viewer' && userRole !== 'RSM Viewer')
                ? [
                    {
                        title: 'Masters', path: PATH_SalesUser.readonlymaster.root, icon: ICONS.master,
                        children: [
                            { title: 'Distributor', path: PATH_SalesUser.readonlymaster.distributor },
                            { title: 'Products', path: PATH_SalesUser.readonlymaster.product },
                            { title: 'Accounts', path: PATH_SalesUser.readonlymaster.account },
                            { title: 'Surgeons', path: PATH_SalesUser.readonlymaster.surgeon },
                            { title: 'Territory Management', path: PATH_SalesUser.readonlymaster.accountterritory },
                        ],
                    },
                ] : []
            ),
            {
                title: 'Data', path: PATH_SalesUser.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_SalesUser.data.inventorypage },
                    { title: 'Gross Sales', path: PATH_SalesUser.data.grosssalepage },
                ],
            },
            {
                title: 'Report', path: PATH_SalesUser.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_SalesUser.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_SalesUser.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_SalesUser.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_SalesUser.report.dealerreportpage },
                    { title: 'My Sales Report', path: PATH_SalesUser.report.salesreportpage },
                    { title: 'Request Report', path: PATH_SalesUser.report.ytddumpreportpage },
                    //  { title: 'Dealer SNS Report', path: PATH_SalesUser.report.dealersnsreportpage },
                    // { title: 'Gross Sales Report', path: PATH_SalesUser.report.grosssalesreportpage },
                ],
            },
        ],
    }
];
export default navConfig;